import queryString from 'query-string';
import fetch from 'globals/wa-fetch';
import { goTo, getSubdomainFromHost } from 'router/navigation';
import { SIGNUP_CODES } from 'pages/signup/constants';
import Entry from '../entry';
import * as Session from 'state/session/helpers';
import {
  set as storageSet,
  getKeys,
  remove as storageRemove,
  setPersistence,
} from 'globals/storage';
import { performTenancyLookup, lookupKeys } from 'globals/regional-api';

import { login } from 'state/session/actions';
import { updateData } from 'pages/signup/main/state/actions';
import { setCompany } from 'stores/company-store';
import { getStore } from 'app/hermes-redux';

type Props = {
  type: string;
};

type State = {
  userEmail: string;
  user: any;
  token: string;
  loading: boolean;
};

class LoginSSO extends React.Component<Props, State> {
  state: State;

  static displayName = 'LoginSSO.displayName';

  constructor(props: Props) {
    super(props);
    this.state = {
      userEmail: '',
      token: '',
      loading: false,
      user: {},
    };
  }

  componentDidMount() {
    const query = queryString.parse(location.search);
    const { RelayState } = query;
    const SSOToken = Session.getSSOToken();

    if (RelayState) {
      try {
        const url = new URL(RelayState as string);
        const params = queryString.parse(url.search);
        const redirect = queryString.parse(url.search)['return_to'];

        const newParams = redirect ? { return_to: redirect } : params;

        goTo(url.pathname, newParams);
      } catch (e) {
        goTo('/');
      }
    }

    if (SSOToken) this.onSSOAuthentication(SSOToken);
  }

  async onSSOAuthentication(SSOToken: string) {
    const { dispatch } = getStore();

    this.setState({ loading: true });

    try {
      await performTenancyLookup(lookupKeys.domain, getSubdomainFromHost());

      const { body: authMobileResponse } = await fetch(`/auth/mobile`, {
        method: 'post',
        version: 1.3,
        headers: {
          'One-Time-Token': SSOToken,
        },
      });

      const { user, company, token: wamToken } = authMobileResponse;

      setPersistence(true);

      Session.setToken(wamToken);

      storageSet(
        getKeys().tokenExpiryTime,
        authMobileResponse.user['token_expiry_time'],
      );

      if (user['signup_state'] === SIGNUP_CODES.SSO_SIGNUP_PROVISIONED) {
        setCompany(company);

        // If first login from sso, the signup flow needs to be completed
        dispatch(
          updateData('initData', {
            user,
            token: wamToken,
            signup_state: user['signup_state'],
          }),
        );

        // if the user needs to complete the signup flow,
        // we need to store the original url in order to redirect the user back to the original page after signup
        storageSet(getKeys().signupReturnUrl, window.location.pathname, false);

        goTo('signup');
      } else {
        // Login straight away.
        dispatch({ type: 'SESSION/LOGIN_USER' });

        await dispatch(login(authMobileResponse));
      }
    } catch (response) {
      if ((response as any).error !== 'redirecting') {
        dispatch({
          type: 'SESSION/LOGIN_USER_FAILURE',
          loginError: Session.getLoginErrorMessage(response),
        });
      }
    } finally {
      this.setState({ loading: false });
      storageRemove(getKeys().SSOToken);
    }
  }

  render() {
    return <Entry isSSOLoading={this.state.loading} type='login' />;
  }
}

export default LoginSSO;
